<template>
  <div class="form-group form-group--select" :class="getClass()">
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <link href="https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/css/select2.min.css" rel="stylesheet" />
    <div class="row">
      <div :class="`col-sm-${component.size}`">
        <label>{{ component.label }}
          <span class="required" v-if="isRequired()">*</span>
        </label>
        <v-select
          :id="component.key"
          v-model="component.data.currentValue"
          class="style-chooser"
          @search="fetchOptions"
          @open="visibilityChanged(true)"
          @close="visibilityChanged(false)"
          placeholder="Selecione uma opção"
          :multiple="component.isMultiselect===true"
          @focus="focusHandler()"
          @search:blur="blurHandler()"
          v-validate="setRules()"
          :name="component.key"
          :disabled="disabledHandler()"
          :data-vv-name="component.key"
          :getOptionLabel="option => option && Array.isArray(option.label) ? option.label[0] : option && option.label ? option.label : option"
          :options="this.data">
          <template slot="option" slot-scope="option">
            <span v-for="(label, index) in option.label" :key="index">
              {{ label }}
            </span>
          </template>
          <template slot="no-options">
            <span v-if="!error">Desculpe, opção não encontrada.</span>
            <span v-else-if="errorMensagem">{{ errorMensagem }}</span>
            <span v-else>Falha ao buscar opções<button type="button" class="btn-link" @click="buscar">clique aqui</button>para tentar novamente.</span>
          </template>
        </v-select>
      </div>
      <span class="help-block help-block--bottom" v-if="errors.has(component.key)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14">
            <g transform="translate(-252 -635)">
              <rect class="cls-1" width="14" height="14" transform="translate(252 635)" />
              <path class="cls-2"
                    d="M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z"
                    transform="translate(251 634)" />
            </g>
          </svg>
          {{ (errors.first(component.key)) }}</span>
      <span class="help-block help-block--bottom"
            v-if="!errors.has(component.key) && component.description">{{ component.description }}</span>
    </div>
  </div>

</template>
<script>
// Mixins
// https://br.vuejs.org/v2/guide/mixins.html
import component from '@/mixins/component'
import api from '../../api/form'
import { mapState } from 'vuex'
import 'select2/dist/js/select2.full.min'
import 'select2/dist/css/select2.min.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import formTransformer from '@/services/formTransformer'

export default {
  mixins: [component],
  props: ['component'],
  inject: ['$validator'],
  name: 'component-select-resouce',
  components: {
    vSelect
  },
  data () {
    return {
      isFocus: false,
      isValue: false,
      isErrors: false,
      values: [],
      focos: false,
      data: [],
      selection: false,
      textDescription: '',
      valueInput: '',
      error: false,
      errorMensagem: ''
    }
  },
  computed: {
    ...mapState({
      components: state => state.formJson.components,
      variables: state => state.config.variables,
      json: state => state.config.json,
      clientKey: state => state.config.clientKey
    })
  },
  methods: {
    selectValue (v) {
      this.component.data.currentValue = { label: v.description, value: v.code }
      this.valueInput = v.description
      this.verificarFocus()
    },
    selectOp (val) {
      this.component.data.currentValue = [val]
    },
    fetchOptions (search, loading) {
      this.valueInput = search
      this.buscar(search)
    },
    verificarFocus () {
      this.focos = true
    },
    getValues () {
      this.values = []

      if (this.component.data.sourceType === 'json') {
        for (let i = 0; i < this.component.data.json.length; i++) {
          this.values.push({
            label: this.component.data.json[i][this.component.data.propertyLabel],
            value: this.component.data.json[i][this.component.data.propertyValue]
          })
        }
      } else if (this.component.data.sourceType === 'values') {
        this.values = this.component.data.sourceValues
      } else if (this.component.data.sourceType === 'injectedJson') {
        if (this.config.json) {
          this.component.data.injectedJson = this.component.data.injectedJson.replace('json', 'this.config.json')
          try {
            /* eslint-disable no-eval */
            let keyCustom = eval(this.component.data.injectedJson)

            if (keyCustom) {
              for (let i = 0; i < keyCustom.length; i++) {
                this.values.push({
                  label: keyCustom[i][this.component.data.propertyLabel],
                  value: keyCustom[i][this.component.data.propertyValue]
                })
              }
            }
          } catch (e) {
            // Ignore error
          }
        }
      }
    },
    async buscar (input) {
      if (this.valueInput.length >= 3 && this.component.autocomplete === true) {
        let grupoFiltros = []
        let subGrouper = []
        let filtrosApi = { grouper: [] }
        let filtrosApisub = { subGrouper: [] }
        this.component.data.filterGroup.forEach(el => {
          grupoFiltros.push(el[0])
        })
        this.component.data.filterSubGroup.forEach(el => {
          subGrouper.push(el[0])
        })
        grupoFiltros.forEach(filtros => {
          if (filtros.typeCondition === 'component') {
            this.components.forEach(comp => {
              if (comp.key === filtros.value) {
                filtrosApi.grouper.push({ 'value': comp.data.currentValue, 'operator': filtros.operator })
              }
            })
          }
          if (filtros.typeCondition === 'custom') {
            filtrosApi.grouper.push({ 'value': filtros.value, 'operator': filtros.operator })
          }
        })
        subGrouper.forEach(filtros => {
          if (filtros.typeCondition === 'component') {
            this.components.forEach(comp => {
              if (comp.key === filtros.value) {
                filtrosApisub.subGrouper.push({ 'value': comp.data.currentValue, 'operator': filtros.operator })
              }
            })
          }
          if (filtros.typeCondition === 'custom') {
            filtrosApisub.subGrouper.push({ 'value': filtros.value, 'operator': filtros.operator })
          }
        })
        let resp = await api.getResource(
          this.clientKey,
          this.component.data.resourceId,
          input,
          filtrosApi,
          filtrosApisub
        ).catch((error) => {
          this.error = true
          if (error.response) {
            resp = error.response
          }
        })

        if (!resp.data.data) {
          this.error = true
          this.errorMensagem = resp.data.mensagem
        }
        resp.data.data.forEach(valor => {
          if (this.data.length === 0) {
            this.data.push({ label: [valor.description], value: valor.code })
          } else {
            resp.data.data.forEach(valor => {
              const found = this.data.find(element => element.label === valor.description)
              if (found) {
              } else {
                if (!this.data.some(item => item.label[0] === valor.description && item.value === valor.code)) {
                  this.data.push({ label: [valor.description], value: valor.code })
                }
              }
            })
          }
        })
      }
    },
    visibilityChanged (visible) {
      const padding = visible ? 320 : null
      formTransformer.changeBottomPaddingPx(padding)
    }
  },

  async created () {
    this.getValues()
    await this.setValue()
    if (this.component.data.currentValue) {
      this.valueInput = this.component.data.currentValue.label
    }
    if (this.component.autocomplete === false) {
      await api.getResourceInitial(this.clientKey, this.component.data.resourceId).then(resp => {
        if (resp.data.data.length === 0) {
          this.data = [{ description: ['Nenhum resultado encontrado'], _id: Math.random() }]
        } else {
          resp.data.data.forEach(valor => {
            this.data.push({ label: [valor.description], value: valor.code })
          })
        }
      })
    } else {
      api.getResourceLimit(this.clientKey, this.component.data.resourceId).then(resp => {
        if (resp.data.data.length === 0) {
          this.data = [{ description: ['Nenhum resultado encontrado'], _id: Math.random() }]
        } else {
          resp.data.data.forEach(valor => {
            this.data.push({ label: [valor.description], value: valor.code })
          })
        }
      })
    }
  },
  // o current value deve vir como array
  watch: {
    'component.data.currentValue': function (after, before) {
      if (after && !Array.isArray(after)) {
        this.component.data.currentValue = [after]
      }
    }
  }
}
</script>

<style>

.select-recurso {
  background-color: RGB(0, 117, 234, 0.16);
  border-left: 1px solid RGBA(0, 0, 0, 0.50);
  border-right: 1px solid RGBA(0, 0, 0, 0.50);
  border-bottom: 1px solid RGBA(0, 0, 0, 0.50);
  padding: 0px;
  position: fixed;
  z-index: 10;
  width: 100%;
  height: auto;
}

.ul :hover {
  background: #0075EA
}

ul, ol {
  padding-left: 12px;
  margin-bottom: 0px !important;
}
</style>
